import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import SampleLibrary from '../../service/SampleLibrary';
import instruments from '../../service/instruments';
import { Rollbar } from '../../context';

export default function withHarpInstrument(WrappedComponent) {
  return function WrapperHarpInstrument(props) {
    const [instrumentReady, setInstrumentReady] = useState(false);
    const instrumentRef = useRef(null);

    const rollbar = useContext(Rollbar.Context);

    /**
     *
     * @param time
     * @param note
     */
    const playNote = (time, note) => {
      if (!instrumentRef.current) {
        return;
      }

      instrumentRef.current.triggerAttackRelease(note.name, note.duration, time, note.velocity);
    };

    const instrumentProps = useMemo(() => ({
          instance: instrumentRef.current,
          ready: instrumentReady,
          playNote: playNote,
        }
    ), [instrumentReady]);

    useEffect(() => {
      let mounted = true;
      setInstrumentReady(false);

      const loadInstrument = () => {
        if (!mounted) {
          return;
        }

        const library = new SampleLibrary({
          baseUrl: '/instruments',
          instruments,
        });

        const samplerPromise = library.loadInstrument('harp');

        samplerPromise
            .then((sampler) => {
              if (!mounted) {
                return;
              }
              sampler.release = 5;
              instrumentRef.current = sampler.toMaster();

              setInstrumentReady(true);
            })
            .catch((error) => {
              rollbar.error(error);
            })
      };

      loadInstrument();

      return () => {
        mounted = false;
      };
    }, []);

    return <WrappedComponent
        instrument={instrumentProps}
        {...props}
    />
  };
}
